import { FC, useEffect, useState } from "react";
import {
  Stack,
  Box,
  useColorModeValue,
  Button,
  Center,
  Text,
} from "@chakra-ui/react";
import { Form, Formik } from "formik";
import Layout from "components/Layout";
import TextInput from "components/TextInput";
import { ILoginPayload } from "interfaces/auth";
import { forgotPasswordValidationSchema } from "utils/validationSchema";
import Logo from "components/Logo";
import useAuth from "hooks/useAuth";
import { useAuthContext } from "components/AuthProvider";
import { useNavigate } from "react-router-dom";

const ForgotPassword: FC = () => {
  const { sendPasswordReset } = useAuth();
  const [isLoading, setLoading] = useState(false);
  const [isSubmitted, setSubmitted] = useState(false);
  const { user } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (user !== null) {
      // logout();
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <Layout withSidebar={false}>
      <Center minH="100vh">
        <Box
          rounded={"lg"}
          bg={useColorModeValue("white", "gray.700")}
          boxShadow={"lg"}
          p={8}
          w="sm"
        >
          <Center mb="6">
            <Logo mb="6" w="60%" />
          </Center>
          {isSubmitted ? (
            <Text mb="10" textAlign="justify">
              Silakan cek email anda. Kami telah mengirim link reset password!
            </Text>
          ) : (
            <Text mb="4" textAlign="justify">
              Silakan isi form berikut dengan email anda yang digunakan untuk
              login, setelah itu kami akan mengirim link reset password ke email
              tersebut.
            </Text>
          )}
          {!isSubmitted ? (
            <Formik<ILoginPayload>
              initialValues={{ email: "", password: "" }}
              validationSchema={forgotPasswordValidationSchema}
              onSubmit={async ({ email }, helpers) => {
                try {
                  setLoading(true);
                  await sendPasswordReset(email);
                } catch (error) {
                  if (error instanceof Error) {
                    helpers.setErrors({ email: error.message });
                  }
                } finally {
                  setLoading(false);
                  setSubmitted(true);
                }
              }}
            >
              <Form>
                <Stack spacing={4}>
                  <TextInput name="email" id="email" label="Email" />
                  <Button
                    colorScheme="green"
                    type="submit"
                    isLoading={isLoading}
                  >
                    Submit
                  </Button>
                </Stack>
              </Form>
            </Formik>
          ) : (
            <Button w="full" onClick={() => navigate("/")} colorScheme="red">
              Kembali ke Login
            </Button>
          )}
        </Box>
      </Center>
    </Layout>
  );
};

export default ForgotPassword;
